import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { IndicatorsGroupers } from "src/pages/Indicators/Panel/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardIndicatorsData } from "../interface";
import Li from "./li";
import * as Styles from "./styles";
import { FilterButton, FilterButtonSelected } from "./styles";

const DashboardListsIndicators: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();
	const [ dataCard, setDataCard] = useState<IDashboardIndicatorsData[]>();
	const [ actualPeriod, setActualPeriod] = useState<boolean>(true);

	const returnName = (value?: string) => {
		if(!value || value === null || value.trim().length === 0)
			return translate("Sem classificação");
		return value;
	};

	const { loading } = useEffectFetchData<IDashboardIndicatorsData[]> (
		"DashboardIndicators/ListClassification", {
			actualPeriod
		},
		({data}) => {
			setDataCard(data && data.length > 0 ? data : [{
				total: 0,
				withoutValue: 0,
				notOnTarget: 0,
				onTarget: 0,
				group: ""
			}] as IDashboardIndicatorsData[]); 

		},[actualPeriod]
	);

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : `${translate("Resumo Indicadores por Classificação")}`}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<RCCGrid container justifyContent="flex-end">
					<RCCTooltip
						text={translate("Período anterior")}
						color="blue"
						styleInline={actualPeriod === false ? FilterButtonSelected : FilterButton}
					>
						<RCCButton 
							color="blue"
							styleInline={actualPeriod === false ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); setActualPeriod(false); }}
						>
							{translate("Anterior")}
						</RCCButton>
					</RCCTooltip>
					<RCCTooltip
						text={translate("Período atual")}
						color="purple" 
						styleInline={actualPeriod === true ? FilterButtonSelected : FilterButton}
					>
						<RCCButton 
							color="purple" 
							styleInline={actualPeriod === true ? FilterButtonSelected : FilterButton}
							onClick={(e) => { e.stopPropagation(); setActualPeriod(true); }}
						>
							{translate("Atual")}
						</RCCButton>
					</RCCTooltip>
				</RCCGrid>
				<Link to={`/indicators/panel/?group=${IndicatorsGroupers.INDICATOR_CLASSIFICATION}`} >
					<RCCTooltip
						text={translate("Painel de indicadores")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="indicators"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/indicators/presentation">
					<RCCTooltip
						text={translate("Apresentação de indicadores")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "presentationChartBar",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			<DefaultBody>

				{dataCard && dataCard.length > 0 && (
					<>
						<Styles.LiTitles>
							<div />
							<div><RCCTooltip text={translate("Total")} color="blue" >{translate("Total")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Sem valor")} color="red" >{translate("Sem valor")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Não atingiu")} color="yellow" >{translate("Não atingiu")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Atingiu a meta")} color="green" >{translate("Atingiu a meta")} </RCCTooltip></div>
						</Styles.LiTitles>

						{dataCard.map((dtIndicators) => (
							<Styles.LiPanelBodyContent key={`classificationIndicators-${dtIndicators.group}`}>
								<div>
									<Title color="purple" size="sm">
										{returnName(dtIndicators.group)} 
									</Title>
								</div>
								<Li data={dtIndicators} classification={dtIndicators.groupId} currentPeriod={actualPeriod ? "S" : "N"}/>
							</Styles.LiPanelBodyContent>
						))}
					</>
				)}

			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardListsIndicators;
